// Spalten verschieben (Lead-Listen, Design-Runde 2).
/** Rein: neue Reihenfolge, wenn `von` an die Stelle von `nach` gezogen wird (der Name bleibt vorn, Festes bewegt sich nicht). */
export function spalteVerschieben(keys: string[], von: string, nach: string, fest: ReadonlySet<string>): string[] {
  if (von === nach || fest.has(von) || fest.has(nach) || !keys.includes(von) || !keys.includes(nach)) return keys;
  const ohne = keys.filter((k) => k !== von);
  const i = ohne.indexOf(nach);
  const vorher = keys.indexOf(von) < keys.indexOf(nach);
  ohne.splice(vorher ? i + 1 : i, 0, von);
  return ohne;
}
